export const RequestTypes = {
  GET: "get",
  POST: "post",
  PUT: "put",
  PATCH: "patch",
  DELETE: "delete",
};

export const responseTypes = {
  success: "Success",
  error: "Error",
};
